{
    "animal": "Contact with animal",
    "animal_bite": "Animal/insect bite/scratch/sting",
    "burglary": "Burglary",
    "earthquake": "Earthquake, earth movement or landslide",
    "explosion": "Explosion",
    "fire": "Fire",
    "flood": "Flood",
    "glassbreakage": "Glass breakage only",
    "hail": "Hail",
    "hurricane": "Hurricane",
    "nw_accidentallother": "Accident all other",
    "nw_accidentaldeath": "Accidental death",
    "nw_advertisinginjury": "Advertising injury",
    "nw_allother": "All other physical damage",
    "nw_bodilyinjury": "Bodily injury",
    "nw_breakage": "Breakage",
    "nw_collapse": "Collapse",
    "nw_collapseexcept": "Collapse - except from weight of ice",
    "nw_crime": "Crime related",
    "nw_directorsandofficers": "Directors and officers liability",
    "nw_earthmovementMobile": "Earth movement - mobile equipment",
    "nw_ecommerce": "E-commerce",
    "nw_employersliability": "Employers liability",
    "nw_emppracticesliability": "Employment practices liability",
    "nw_empreltdliability": "Employment related liability",
    "nw_equipmentbreakdown": "Equipment breakdown or power surge (not from weather)",
    "nw_escapeLiquidFuel": "Escape of liquid fuel from on premises storage system",
    "nw_fallingobj": "Object hit vehicle",
    "nw_faultywork": "Faulty work",
    "nw_feed": "Damage caused by feed",
    "nw_foodrelated": "Food related",
    "nw_foundation": "Foundation or structure cracking",
    "nw_freezing": "Freezing",
    "nw_fuel": "Damage by fuel",
    "nw_garagekeepers": "Garagekeepers/garage operations",
    "nw_hdliabilitymedpay": "Home day care liability and medical payments",
    "nw_hiredornonowned": "Hired or non-owned auto",
    "nw_identitytheft": "Identity theft",
    "nw_InTransit": "In transit",
    "nw_injurytype": "Injury type of para/quad, blindness, amputation",
    "nw_lead": "Lead",
    "nw_leadpaint": "Lead paint",
    "nw_liabilitymedpay": "Liability and medical payments",
    "nw_lightning": "Lightning",
    "nw_loadunload": "Loading and unloading",
    "nw_lostitem": "Lost item or mysterious disappearance",
    "nw_medicalpayments": "Medical payments only",
    "nw_medicalpip": "Medical and PIP",
    "nw_minesubsidence": "Mine subsidence",
    "nw_misapplication": "Misapplication",
    "nw_mobileequipment": "Mobile equipment",
    "nw_other_liability": "Other liability type",
    "nw_other": "Other",
    "nw_pollution": "Pollution",
    "nw_professionalliability": "Professional liability",
    "nw_propertydamage": "Property damage",
    "nw_railroad": "Railroad accident",
    "nw_rejecteddel": "Rejected delivery of grain/product",
    "nw_sewerbackup": "Sewer backup",
    "nw_silicosisasbestos": "Silicosis/asbestos",
    "nw_slipfallacc": "Slip and fall/accident injury",
    "nw_smoke": "Smoke",
    "nw_sprinklerleakage": "Sprinkler leakage",
    "nw_terrorism": "Terrorism",
    "nw_theft": "Theft",
    "nw_theftbyemployee": "Theft by employee",
    "nw_theftfromauto": "Theft of items from vehicle",
    "nw_utilityservices": "Utility services or power outage",
    "nw_vehiclewaterandair": "Damage from vehicle, watercraft or aircraft",
    "nw_water": "Water damage (from weather)",
    "nw_waternonweather": "Water damage (not from weather)",
    "nw_weatherOtherMobile": "Weather other - mobile equipment",
    "nw_weightofice": "Weight of ice, snow or sleet",
    "riotandcivil": "Riot",
    "sinkhole": "Sinkhole",
    "snowice": "Snow/ice",
    "structfailure": "Structural failure",
    "vandalism": "Vandalism",
    "volcanic": "Volcanic action",
    "wind": "Wind"
}